import { render, staticRenderFns } from "./EditAddress.vue?vue&type=template&id=13bf232f"
import script from "./EditAddress.vue?vue&type=script&lang=ts"
export * from "./EditAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13bf232f')) {
      api.createRecord('13bf232f', component.options)
    } else {
      api.reload('13bf232f', component.options)
    }
    module.hot.accept("./EditAddress.vue?vue&type=template&id=13bf232f", function () {
      api.rerender('13bf232f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/EditAddress.vue"
export default component.exports